import { createToken } from '@react-apps/core';
import type { SalesRepositoryImpl } from '../data/repositories/sales.repository.impl';

export const SalesRepositoryToken =
  createToken<SalesRepositoryImpl>('SalesRepository');
